import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import './HowItWorks.css';

interface Step {
  number: number;
  titleNl: string;
  titleEn: string;
  descriptionNl: string;
  descriptionEn: string;
}

const steps: Step[] = [
  {
    number: 1,
    titleNl: 'Neem Contact Op',
    titleEn: 'Say Hello',
    descriptionNl: 'Neem contact met ons op via onze website of bel ons direct. We staan klaar om uw behoeften te begrijpen.',
    descriptionEn: 'Reach out to us through our website or give us a call. We\'re ready to understand your needs.',
  },
  {
    number: 2,
    titleNl: 'Gesprek met Ons Team',
    titleEn: 'Talk to Our Team',
    descriptionNl: 'Ontmoet één van onze gespecialiseerde consultants voor een diepgaand gesprek over uw doelen en uitdagingen.',
    descriptionEn: 'Meet with one of our specialist consultants for an in-depth discussion about your goals and challenges.',
  },
  {
    number: 3,
    titleNl: 'Krijg Ondersteuning',
    titleEn: 'Get Support',
    descriptionNl: 'Ontvang persoonlijke begeleiding en ondersteuning gedurende het hele recruitment proces tot succesvolle plaatsing.',
    descriptionEn: 'Receive personalized guidance and support throughout the entire recruitment process to successful placement.',
  },
];

const HowItWorks: React.FC = () => {
  const { language } = useLanguage();

  return (
    <section className="how-it-works">
      <div className="how-it-works-container">
        <div className="how-it-works-left">
          <p className="how-it-works-subtitle">
            {language === 'nl' ? 'Wacht niet om gevonden te worden.' : 'Don\'t Wait To Get Found.'}
          </p>
          <h2 className="how-it-works-title">
            {language === 'nl' ? 'Vind uw mensen snel.' : 'Find Your People Quick.'}
          </h2>
          <div className="how-it-works-image">
            <img 
              src="/images/pexels-fauxels-3184416.jpg" 
              alt={language === 'nl' ? 'Teamoverleg op kantoor' : 'Team meeting in office'}
            />
          </div>
        </div>

        <div className="how-it-works-right">
          <h2 className="how-it-works-title-mobile">
            {language === 'nl' ? 'Hoe Het Werkt' : 'How It Works'}
          </h2>
          <div className="steps-container">
            {steps.map((step, index) => (
              <div key={index} className="step">
                <div className="step-icon">
                  <svg
                    className="checkmark"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="3"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </div>
                <div className="step-content">
                  <h3 className="step-title">
                    {step.number}. {language === 'nl' ? step.titleNl : step.titleEn}
                  </h3>
                  <p className="step-description">
                    {language === 'nl' ? step.descriptionNl : step.descriptionEn}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
